import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import useTopPanel from 'hooks/useTopPanel';
import StaffKpiAddModal from './AddModal';
import EarningsModal from './EarningsModal';
import BaseTable from 'components/ui/tables/BaseTable';
import SimpleSearchInput from 'components/SearchInputNavbar';

const StaffKpi = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const [refetch, setRefetch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEarnings, setOpenEarnings] = useState(false);
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('settings.staffKpi.title')}</div>
    );
  }, [i18n.language]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center gap-8'>
          <div className='header-actions filter-box flex items-center w-full'>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 flex items-center justify-center gap-2'>
            <Button
              variant='base'
              color='info'
              onClick={() => setRefetch(true)}
              disable={`${refetch}`}
            >
              <i className={`bi bi-arrow-repeat${refetch ? ' animate-spin' : ''}`} />
            </Button>
            <Button
              variant='base'
              color='primary'
              onClick={() => setOpenEarnings(true)}
              startIcon={<i className='bi bi-cash-coin' />}
            >
              {t('settings.staffKpi.earnings.title')}
            </Button>
            <Button
              variant='base'
              color='success'
              onClick={() => setOpenModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/staff-kpi/index'
          emitTableColumns={{ open, setOpen }}
          tableName='admin/staff-kpi/index'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'user', label: t('common.fields.staff') },
            { code: 'type', label: t('common.fields.type') },
            { code: 'count_type_text', label: t('settings.staffKpi.fields.countType') },
            { code: 'price', label: t('settings.staffKpi.fields.price') },
          ]}
          columns={[
            { code: 'id' },
            { code: 'user', type: 'nested', childStr: 'name' },
            { code: 'type', type: 'nested', childStr: 'name' },
            { code: 'count_type_text' },
            {
              code: 'price',
              type: 'conditionalPrice',
              conditionField: 'count_type',
              conditionValue: 2,
            },
          ]}
          actionModal={{
            setOpen: setOpenModal,
            setData: setItem,
            btnColor: 'warning',
            icon: 'bi bi-pencil-square',
          }}
          actionDelete={{
            link: 'admin/staff-kpi/delete',
            method: 'post',
            paramId: true,
            key: 'id',
          }}
        />
      </div>

      {openModal && (
        <StaffKpiAddModal
          open={openModal}
          item={item}
          setItem={setItem}
          setOpen={setOpenModal}
          setRefetch={setRefetch}
        />
      )}
      {openEarnings && (
        <EarningsModal open={openEarnings} setOpen={setOpenEarnings} />
      )}
    </div>
  );
};

export default memo(StaffKpi);
